import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-100/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 cursor-pointer group">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-movie-2-line text-primary-500 text-2xl group-hover:scale-110 transition-transform duration-300"></i>
            </div>
            <span className="text-xl font-heading font-bold text-foreground-50 whitespace-nowrap">
              久久影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                location.pathname === '/'
                  ? 'text-primary-500 font-medium'
                  : 'text-foreground-300 hover:text-foreground-50'
              }`}
            >
              首页
            </Link>
            {categories.filter(c => c.slug !== 'all').map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-300 hover:text-foreground-50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                location.pathname === '/about'
                  ? 'text-primary-500 font-medium'
                  : 'text-foreground-300 hover:text-foreground-50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索影视..."
                className="w-48 pl-9 pr-4 py-2 rounded-full bg-background-200 text-sm text-foreground-50 placeholder-foreground-500 border border-background-300 focus:outline-none focus:border-primary-500/50 transition-colors duration-200"
              />
              <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-foreground-500 text-sm"></i>
              </div>
            </div>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-50"
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-t border-background-200/50">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link
              to="/"
              className={`text-sm py-2 px-3 rounded-lg cursor-pointer transition-colors duration-200 ${
                location.pathname === '/'
                  ? 'bg-primary-500/15 text-primary-500 font-medium'
                  : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50'
              }`}
            >
              首页
            </Link>
            {categories.filter(c => c.slug !== 'all').map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm py-2 px-3 rounded-lg cursor-pointer transition-colors duration-200 ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500/15 text-primary-500 font-medium'
                    : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm py-2 px-3 rounded-lg cursor-pointer transition-colors duration-200 ${
                location.pathname === '/about'
                  ? 'bg-primary-500/15 text-primary-500 font-medium'
                  : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50'
              }`}
            >
              关于我们
            </Link>
            <div className="pt-2">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索影视..."
                  className="w-full pl-9 pr-4 py-2.5 rounded-full bg-background-200 text-sm text-foreground-50 placeholder-foreground-500 border border-background-300 focus:outline-none focus:border-primary-500/50"
                />
                <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                  <i className="ri-search-line text-foreground-500 text-sm"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}